import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eTongHopSinhVienActionIds,
  ITongHopSinhVienActionTypes,
  ITongHopSinhVienDataType,
} from "../../action-types/report/ITongHopSinhVienActionTypes";
import { rootActions } from "../../actions/rootActions";
import { tongHopSinhVienApi } from "../../../api/report/tongHopSinhVienApi";
import { ILuyKeSinhVienRespone } from "../../../model/respone/report/ITongHopSinhVienRespone";
import {
  IBienLaiThu,
  IBienLaiThuViewModel,
} from "../../../model/respone/bien-lai/IBienLaiThu";
import { IMucThuKhacSinhVienViewModel } from "../../../model/respone/chung-tu/IMucThuKhacSinhVienViewModel";

export function* tongHopSinhVienSaga(): any {
  yield takeLatest(
    eTongHopSinhVienActionIds.LOAD_LUY_KE_SO_LIEU_START,
    loadWorker
  );
  yield takeLatest(
    eTongHopSinhVienActionIds.LOAD_LUY_KE_BIEN_LAI_START,
    loadBienLaiWorker
  );
  yield takeLatest(
    eTongHopSinhVienActionIds.LOAD_LUY_KE_MUC_THU_START,
    loadMucThuWorker
  );
}

function* loadWorker(action: ITongHopSinhVienActionTypes): any {
  const res: IBaseRespone = yield call(
    tongHopSinhVienApi.SelectLuyKe,
    action.payload as string
  );
  if (res.is_success) {
    const data: ILuyKeSinhVienRespone = res.data;
    yield put(rootActions.report.sinhVien.LOAD_LUY_KE_SO_LIEU_SUCCESS(data));
  } else {
    yield put(
      rootActions.report.sinhVien.LOAD_LUY_KE_SO_LIEU_ERROR(
        action.payload as string
      )
    );
  }
}

function* loadBienLaiWorker(action: ITongHopSinhVienActionTypes): any {
  const res: IBaseRespone = yield call(
    tongHopSinhVienApi.SelectBienLaiLuyKe,
    action.payload as string
  );
  if (res.is_success) {
    const data: ITongHopSinhVienDataType<IBienLaiThuViewModel[]> = {
      id_sv: action.payload as string,
      data: res.data,
    };
    yield put(rootActions.report.sinhVien.LOAD_LUY_KE_BIEN_LAI_SUCCESS(data));
  } else {
    yield put(
      rootActions.report.sinhVien.LOAD_LUY_KE_BIEN_LAI_ERROR(
        action.payload as string
      )
    );
  }
}

function* loadMucThuWorker(action: ITongHopSinhVienActionTypes): any {
  const res: IBaseRespone = yield call(
    tongHopSinhVienApi.SelectMucThuLuyKe,
    action.payload as string
  );
  if (res.is_success) {
    const data: ITongHopSinhVienDataType<IMucThuKhacSinhVienViewModel[]> = {
      id_sv: action.payload as string,
      data: res.data,
    };
    yield put(rootActions.report.sinhVien.LOAD_LUY_KE_MUC_THU_SUCCESS(data));
  } else {
    yield put(
      rootActions.report.sinhVien.LOAD_LUY_KE_MUC_THU_ERROR(
        action.payload as string
      )
    );
  }
}
